import { type DoctorsService } from './doctors/DoctorsService'
import type { LocalStorageService } from './local-storage/LocalStorageService'
import { type MemoryListService } from './memory-list/MemoryListService'
import { type PatientService } from './patient/PatientService'
import { type VisitService } from './visit/VisitService'
import { type SecretaryService } from './secretary/SecretaryService'
import { type QueueService } from './queue/QueueService'
import { type ReferralService } from './referral/ReferralService'
import { type AppointmentService } from './appointment/AppointmentService'

const localStorageServiceKey = 'localStorageService'
const patientServiceKey = 'patientService'
const visitServiceKey = 'visitService'
const memoryListServiceKey = 'memoryListService'
const doctorsServiceKey = 'doctorsService'
const secretaryServiceKey = 'secretaryService'
const queueServiceKey = 'queueService'
const referralServiceKey = 'referralService'
const appointmentServiceKey = 'appointmentService'

const _services: Record<string, any> = {}

// LocalStorageService
const setLocalStorageService = (service: LocalStorageService) => {
  _services[localStorageServiceKey] = service
}

const getLocalStorageService = (): LocalStorageService => {
  return _services[localStorageServiceKey]
}

// PatientService
const setPatientService = (service: PatientService) => {
  _services[patientServiceKey] = service
}

const getPatientService = (): PatientService => {
  return _services[patientServiceKey]
}

// VisitService
const setVisitService = (service: VisitService) => {
  _services[visitServiceKey] = service
}

const getVisitService = (): VisitService => {
  return _services[visitServiceKey]
}

// MemoryListService
const setMemoryListService = (service: MemoryListService) => {
  _services[memoryListServiceKey] = service
}

const getMemoryListService = (): MemoryListService => {
  return _services[memoryListServiceKey]
}

// DoctorsService
const setDoctorsService = (service: DoctorsService) => {
  _services[doctorsServiceKey] = service
}

const getDoctorsService = (): DoctorsService => {
  return _services[doctorsServiceKey]
}

// SecretaryService
const setSecretaryService = (service: SecretaryService) => {
  _services[secretaryServiceKey] = service
}

const getSecretaryService = (): SecretaryService => {
  return _services[secretaryServiceKey]
}

// QueueService
const setQueueService = (service: QueueService) => {
  _services[queueServiceKey] = service
}

const getQueueService = (): QueueService => {
  return _services[queueServiceKey]
}

// ReferralService
const setReferralService = (service: ReferralService) => {
  _services[referralServiceKey] = service
}

const getReferralService = (): ReferralService => {
  return _services[referralServiceKey]
}

const setAppointmentService = (service: AppointmentService) => {
  _services[appointmentServiceKey] = service
}

const getAppointmentService = (): AppointmentService => {
  return _services[appointmentServiceKey]
}

export {
  getLocalStorageService,
  setLocalStorageService,
  setPatientService,
  getPatientService,
  setVisitService,
  getVisitService,
  setMemoryListService,
  getMemoryListService,
  setDoctorsService,
  getDoctorsService,
  setSecretaryService,
  getSecretaryService,
  setQueueService,
  getQueueService,
  setReferralService,
  getReferralService,
  setAppointmentService,
  getAppointmentService
}
